import { render, staticRenderFns } from "./AttributeCard.vue?vue&type=template&id=ccf0576e&scoped=true"
import script from "./AttributeCard.vue?vue&type=script&lang=js"
export * from "./AttributeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf0576e",
  null
  
)

export default component.exports